import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';
import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';
import { EmbeddedWelcomePage } from '~/modules/link-farm/components/EmbeddedWelcomePage/EmbeddedWelcomePage';
import { WelcomeLogo } from '~/modules/link-farm/components/WelcomeLogo/WelcomeLogo.tsx';

import { PageTemplate } from './components/PageTemplate';

export function Home() {
  const { t } = useTranslation('navigation', { keyPrefix: 'sidebar.items' });

  const [isEmbeddedContentEnabled] = useFeatureFlags([
    FEATURE_FLAGS.WmgHomepageUsesEmbeddedContent,
  ]);

  return (
    <PageTemplate
      showGreeting={true}
      containerClassName={cn({
        'gap-0': isEmbeddedContentEnabled,
      })}
    >
      <Helmet>
        <title>{t('wmgHome')}</title>
      </Helmet>
      {isEmbeddedContentEnabled ? (
        <EmbeddedWelcomePage />
      ) : (
        <div className="flex flex-row gap-[3em] overflow-auto pt-[6em]">
          <WelcomeLogo />
        </div>
      )}
    </PageTemplate>
  );
}

Home.displayName = 'LinkFarm';
